<template>
    <div class="a-radio">
        <div
            v-for="(item, itemIdx) in items"
            v-bind:key="item.label"
            class="a-radio__item"
            :class="{'a-radio__item--selected': item.value === value }"
            @click="handleClick(itemIdx, item.value)"
        >
            {{ item.label }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [String, Boolean],
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: null
        }
    },
    methods: {
        handleClick(itemIdx, value) {
            // boolean switch
            if(this.items.length === 2 && value === this.value) {
                this.$emit('input', this.items[Math.abs(itemIdx - 1)].value)
            } else {
                this.$emit('input', value)
            }
        }
    }
}
</script>